/** Rough spoken-duration estimate for greeting / voice scripts. */

const WPM_BY_LANGUAGE = {
  "tr-TR": 140,
  "en-US": 150,
  "de-DE": 130,
  "ar-SA": 120,
};

export const GREETING_MAX_SECONDS = 20;

export const estimateSpeechDuration = (text, language = "en-US") => {
  const value = (text || "").trim();
  const chars = value.length;
  if (!chars) {
    return { seconds: 0, chars: 0, words: 0 };
  }
  const words = value.split(/\s+/).filter(Boolean).length;
  const wpm = WPM_BY_LANGUAGE[language] || WPM_BY_LANGUAGE["en-US"];
  const seconds = Math.max(1, Math.ceil((words / wpm) * 60));
  return { seconds, chars, words };
};

export const exceedsGreetingLimit = (text, language) =>
  estimateSpeechDuration(text, language).seconds > GREETING_MAX_SECONDS;
